/* eslint-disable no-plusplus */

/**
 * Parallax method via css transforming scale + translate
 * See technique details at https://developers.google.com/web/updates/2016/12/performant-parallaxing
 * @param {DOMelement} clip - the parent parallax container
 */
var onResize = function onResize(details) {
  for (var i = 0; i < details.length; i++) {
    var current = details[i];
    var isSticky = current.sticky;
    var container = current.node.parentNode;
    var clip = container.parentNode;
    var previousCover = current.previousCover;
    var _current = current,
        nextCover = _current.nextCover;
    var rate = current.node.getAttribute('parallax');
    var parallaxStart = previousCover ? previousCover.offsetTop + previousCover.offsetHeight : 0;
    var scrollbarWidth = isSticky ? 0 : clip.offsetWidth - clip.clientWidth;
    var height = current.node.offsetHeight;
    var depth = 0;

    if (rate) {
      depth = 1 - 1 / rate;
    } else {
      var parallaxEnd = nextCover ? nextCover.offsetTop : container.offsetHeight;
      depth = (height - parallaxEnd + parallaxStart) / (height - clip.clientHeight);
    }

    if (isSticky) {
      depth = 1.0 / depth;
    }

    var scale = 1.0 / (1.0 - depth);
    var heightOffset = height - clip.clientHeight;
    var standardHeightDiff = parallaxStart - depth * heightOffset;
    var standardOffset = standardHeightDiff * scale;
    var dx = scrollbarWidth * (scale - 1);
    var dy = standardOffset;

    if (isSticky) {
      var scaledProgress = 1 - scale;
      var stickyScrollOffset = -(clip.scrollHeight - parallaxStart - height);
      dy = stickyScrollOffset * scaledProgress;
    }

    current.node.style.transform = "scale(".concat(1 - depth, ") translate3d(").concat(dx, "px, ").concat(dy, "px, ").concat(depth, "px)");
  }
};

var initParallax = function initParallax(clip) {
  var parallax = clip.querySelectorAll('*[parallax]');
  var parallaxDetails = [];
  var sticky = false;
  var fixedPos = document.createElement('div');
  fixedPos.style.position = 'fixed';
  fixedPos.style.top = '0';
  fixedPos.style.width = '1px';
  fixedPos.style.height = '1px';
  fixedPos.style.zIndex = 1;
  document.body.insertBefore(fixedPos, document.body.firstChild);

  for (var i = 0; i < parallax.length; i++) {
    var elem = parallax[i];
    var container = elem.parentNode;

    if (getComputedStyle(container).overflow !== 'visible') {
      console.error('Need non-scrollable container to apply perspective for', elem);
      continue; // eslint-disable-line
    }

    if (clip && container.parentNode !== clip) {
      console.warn('Currently we only track a single overflow clip, but elements from multiple clips found.', elem);
    }

    var parentClip = container.parentNode;

    if (getComputedStyle(parentClip).overflow === 'visible') {
      console.error('Parent of sticky container should be scrollable element', elem);
    }

    var perspectiveElement = void 0;

    if (sticky || getComputedStyle(parentClip).webkitOverflowScrolling) {
      sticky = true;
      perspectiveElement = container;
    } else {
      perspectiveElement = parentClip;
      container.style.transformStyle = 'preserve-3d';
    }

    perspectiveElement.style.perspectiveOrigin = 'bottom right';
    perspectiveElement.style.perspective = '1px';

    if (sticky) {
      elem.style.position = '-webkit-sticky';
      elem.style.top = '0';
    }

    elem.style.transformOrigin = 'bottom right'; // Find the previous and next elements to parallax between.

    var previousCover = parallax[i].previousElementSibling;

    while (previousCover && previousCover.hasAttribute('parallax')) {
      previousCover = previousCover.previousElementSibling;
    }

    var nextCover = parallax[i].nextElementSibling;

    while (nextCover && !nextCover.hasAttribute('parallax-cover')) {
      nextCover = nextCover.nextElementSibling;
    }

    parallaxDetails.push({
      node: parallax[i],
      top: parallax[i].offsetTop,
      sticky: !!sticky,
      nextCover: nextCover,
      previousCover: previousCover
    });
  }

  clip.addEventListener('scroll', function () {
    for (var _i = 0; _i < parallaxDetails.length; _i++) {
      var display = 'block';

      if (parallaxDetails[_i].node.style.display !== display) {
        parallaxDetails[_i].node.style.display = display;
      }
    }
  });
  window.addEventListener('resize', onResize.bind(null, parallaxDetails));
  onResize(parallaxDetails);

  for (var _i2 = 0; _i2 < parallax.length; _i2++) {
    parallax[_i2].parentNode.insertBefore(parallax[_i2], parallax[_i2].parentNode.firstChild);
  }
};

export default initParallax;